import React from 'react';
import { motion } from 'framer-motion';

const testimonials = [
    {
        quote: "בר הפך את הבית שלנו למקום שלא רוצים לצאת ממנו. המקצועיות והדיוק שלו הם ברמה אחרת.",
        author: "משפחת כהן, תל אביב"
    },
    {
        quote: "תהליך העבודה היה נעים ומסודר, והתוצאה הסופית עלתה על כל הציפיות שלנו.",
        author: "דניאל ורוני, הרצליה"
    },
    {
        quote: "עיצוב נקי, חכם ופרקטי. בר ידע בדיוק איך לתרגם את החלומות שלנו למציאות.",
        author: "אמיר, רמת גן"
    }
];

const Testimonials = () => {
    return (
        <section id="testimonials" className="section testimonials-section">
            <div className="container">
                <h2 className="section-title">לקוחות מספרים</h2>
                <div className="testimonials-grid">
                    {testimonials.map((item, index) => (
                        <motion.div
                            key={index}
                            className="testimonial-card"
                            initial={{ opacity: 0, scale: 0.95 }}
                            whileInView={{ opacity: 1, scale: 1 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.5, delay: index * 0.1 }}
                        >
                            <p className="quote">"{item.quote}"</p>
                            <p className="author">- {item.author}</p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Testimonials;
